import { render, staticRenderFns } from "./TableNew.vue?vue&type=template&id=1baeceb9&scoped=true&"
import script from "./TableNew.vue?vue&type=script&lang=ts&"
export * from "./TableNew.vue?vue&type=script&lang=ts&"
import style0 from "./TableNew.vue?vue&type=style&index=0&id=1baeceb9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baeceb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})
